import { leonMediaArray } from './leonMedia'
import { leonBio } from './leonBios'
import { larryProfileReviewHinge, larryProfileReviewBumble, larryProfileReviewTinder } from './leonProfileReviews'

export const leonDatingProfileHinge = {
  _id: 'leonDatingProfileHingeId',
  userId: 'leonUserId',
  email: 'leon@email.com',
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: leonMediaArray[3]._id,
      mediaItemURL: leonMediaArray[3].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: leonMediaArray[3].type,
      caption: leonMediaArray[3].captions[1],
      subcaption: leonMediaArray[3].subcaptions[1],
    },
    {
      mediaItemId: leonMediaArray[0]._id,
      mediaItemURL: leonMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: leonMediaArray[0].type,
      caption: leonMediaArray[0].captions[1],
      subcaption: leonMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: leonMediaArray[1]._id,
      mediaItemURL: leonMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: leonMediaArray[1].type,
      caption: leonMediaArray[1].captions[1],
      subcaption: leonMediaArray[1].subcaptions[1],
    },
    {
      mediaItemId: leonMediaArray[9]._id,
      mediaItemURL: leonMediaArray[9].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: leonMediaArray[9].type,
      caption: leonMediaArray[9].captions[0],
      subcaption: leonMediaArray[9].subcaptions[2],
    },
    {
      mediaItemId: leonMediaArray[8]._id,
      mediaItemURL: leonMediaArray[8].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: leonMediaArray[8].type,
      caption: leonMediaArray[8].captions[2],
      subcaption: leonMediaArray[8].subcaptions[0],
    },
    {
      mediaItemId: leonMediaArray[6]._id,
      mediaItemURL: leonMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: leonMediaArray[6].type,
      caption: leonMediaArray[6].captions[1],
      subcaption: leonMediaArray[6].subcaptions[2],
    }
  ],
  bio: {
    bioItemsId: leonBio._id,
    vitalInfo: { ...leonBio.vitalInfo },
    prompts: [
      { ...leonBio.prompts[0] },
      { ...leonBio.prompts[1] },
      { ...leonBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: ['', '', '', '', ''],
  },
  profileReviews: [
    { ...larryProfileReviewHinge }
  ],
  mediaItems: [ ...leonMediaArray ],
  bioItems: { ...leonBio },
}

export const leonDatingProfileBumble = {
  _id: 'leonDatingProfileBumbleId',
  userId: 'leonUserId',
  email: 'leon@email.com',
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: leonMediaArray[3]._id,
      mediaItemURL: leonMediaArray[3].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: leonMediaArray[3].type,
      caption: leonMediaArray[3].captions[1],
      subcaption: leonMediaArray[3].subcaptions[1],
    },
    {
      mediaItemId: leonMediaArray[0]._id,
      mediaItemURL: leonMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: leonMediaArray[0].type,
      caption: leonMediaArray[0].captions[1],
      subcaption: leonMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: leonMediaArray[1]._id,
      mediaItemURL: leonMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: leonMediaArray[1].type,
      caption: leonMediaArray[1].captions[1],
      subcaption: leonMediaArray[1].subcaptions[1],
    },
    {
      mediaItemId: leonMediaArray[9]._id,
      mediaItemURL: leonMediaArray[9].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: leonMediaArray[9].type,
      caption: leonMediaArray[9].captions[0],
      subcaption: leonMediaArray[9].subcaptions[2],
    },
    {
      mediaItemId: leonMediaArray[8]._id,
      mediaItemURL: leonMediaArray[8].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: leonMediaArray[8].type,
      caption: leonMediaArray[8].captions[2],
      subcaption: leonMediaArray[8].subcaptions[0],
    },
    {
      mediaItemId: leonMediaArray[6]._id,
      mediaItemURL: leonMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: leonMediaArray[6].type,
      caption: leonMediaArray[6].captions[1],
      subcaption: leonMediaArray[6].subcaptions[2],
    }
  ],
  bio: {
    bioItemsId: leonBio._id,
    vitalInfo: { ...leonBio.vitalInfo },
    prompts: [
      { ...leonBio.prompts[0] },
      { ...leonBio.prompts[1] },
      { ...leonBio.prompts[2] }
    ],
    aboutMe: leonBio.aboutMe[0],
    hobbies: [leonBio.hobbies[0], leonBio.hobbies[1], leonBio.hobbies[2], leonBio.hobbies[3], leonBio.hobbies[4] ],
  },
  profileReviews: [
    { ...larryProfileReviewBumble }
  ],
  mediaItems: [ ...leonMediaArray ],
  bioItems: { ...leonBio },
}

export const leonDatingProfileTinder = {
  _id: 'leonDatingProfileTinderId',
  userId: 'leonUserId',
  email: 'leon@email.com',
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: leonMediaArray[3]._id,
      mediaItemURL: leonMediaArray[3].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: leonMediaArray[3].type,
      caption: leonMediaArray[3].captions[1],
      subcaption: leonMediaArray[3].subcaptions[1],
    },
    {
      mediaItemId: leonMediaArray[0]._id,
      mediaItemURL: leonMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: leonMediaArray[0].type,
      caption: leonMediaArray[0].captions[1],
      subcaption: leonMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: leonMediaArray[1]._id,
      mediaItemURL: leonMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: leonMediaArray[1].type,
      caption: leonMediaArray[1].captions[1],
      subcaption: leonMediaArray[1].subcaptions[1],
    },
    {
      mediaItemId: leonMediaArray[9]._id,
      mediaItemURL: leonMediaArray[9].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: leonMediaArray[9].type,
      caption: leonMediaArray[9].captions[0],
      subcaption: leonMediaArray[9].subcaptions[2],
    },
    {
      mediaItemId: leonMediaArray[8]._id,
      mediaItemURL: leonMediaArray[8].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: leonMediaArray[8].type,
      caption: leonMediaArray[8].captions[2],
      subcaption: leonMediaArray[8].subcaptions[0],
    },
    {
      mediaItemId: leonMediaArray[6]._id,
      mediaItemURL: leonMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: leonMediaArray[6].type,
      caption: leonMediaArray[6].captions[1],
      subcaption: leonMediaArray[6].subcaptions[2],
    }
  ],
  bio: {
    bioItemsId: leonBio._id,
    vitalInfo: { ...leonBio.vitalInfo },
    prompts: [
      { ...leonBio.prompts[0] },
      { ...leonBio.prompts[1] },
      { ...leonBio.prompts[2] }
    ],
    aboutMe: leonBio.aboutMe[0],
    hobbies: [leonBio.hobbies[0], leonBio.hobbies[1], leonBio.hobbies[2], leonBio.hobbies[3], leonBio.hobbies[4] ],
  },
  profileReviews: [
    { ...larryProfileReviewTinder }
  ],
  mediaItems: [ ...leonMediaArray ],
  bioItems: { ...leonBio },
}